import { Card, CardContent } from '@/components/ui/card';

/**
 * Consistent empty-state card: centered icon + muted message (+ optional
 * children for a call-to-action). Reconciles the `p-8` / `p-12` / `py-16`
 * variants that were scattered across the admin pages onto a single `p-12`.
 */
const EmptyState = ({ icon: Icon, message, children, testId }) => (
  <Card data-testid={testId}>
    <CardContent className="p-12 text-center">
      {Icon ? <Icon className="text-muted-foreground mx-auto mb-4" size={40} /> : null}
      {message ? <p className="text-muted-foreground">{message}</p> : null}
      {children}
    </CardContent>
  </Card>
);

export default EmptyState;
